import * as actionTypes from "./actionTypes";
import {
  ACTIVATE_USERS_FAILED,
  ACTIVATE_USERS_START,
  ACTIVATE_USERS_SUCCESS,
  COMPANY_FETCH_FAILED,
  COMPANY_FETCH_START,
  COMPANY_FETCH_SUCCESS,
  COMPANY_SWITCH_FAILED,
  COMPANY_SWITCH_START,
  COMPANY_SWITCH_SUCCESS,
  CREATE_COMPANY_FAILED,
  CREATE_COMPANY_START,
  CREATE_COMPANY_SUCCESS,
  DEACTIVATE_USERS_FAILED,
  DEACTIVATE_USERS_START,
  DEACTIVATE_USERS_SUCCESS,
  DELETE_CONNECTED_ACCOUNT_FAILED,
  DELETE_CONNECTED_ACCOUNT_START,
  DELETE_CONNECTED_ACCOUNT_SUCCESS,
  DELETE_USERS_FAILED,
  DELETE_USERS_START,
  DELETE_USERS_SUCCESS,
  FETCH_ACTIVE_COMPANY_USERS_FAILED,
  FETCH_ACTIVE_COMPANY_USERS_START,
  FETCH_ACTIVE_COMPANY_USERS_SUCCESS,
  FETCH_COMPANY_USER_INFO_FAILED,
  FETCH_COMPANY_USER_INFO_START,
  FETCH_COMPANY_USER_INFO_SUCCESS,
  GET_CONNECTED_ACCOUNTS_FAILED,
  GET_CONNECTED_ACCOUNTS_START,
  GET_CONNECTED_ACCOUNTS_SUCCESS,
  GET_USER_LIST_FAILED,
  GET_USER_LIST_START,
  GET_USER_LIST_SUCCESS,
  REINVITE_USERS_FAILED,
  REINVITE_USERS_START,
  REINVITE_USERS_SUCCESS,
  FETCH_COMPANY_WISE_CONFIG_USER_START,
  FETCH_COMPANY_WISE_CONFIG_USER_SUCCESS,
  FETCH_COMPANY_WISE_CONFIG_USER_FAILED,
  UPDATE_COMPANY_WISE_CONFIG_USER_START,
  UPDATE_COMPANY_WISE_CONFIG_USER_SUCCESS,
  UPDATE_COMPANY_WISE_CONFIG_USER_FAILED,
  SEND_CHANGE_EMAIL_OTP_START,
  SEND_CHANGE_EMAIL_OTP_FAILED,
  SEND_CHANGE_EMAIL_OTP_SUCCESS,
  CHANGE_ACCOUNT_EMAIL_START,
  CHANGE_ACCOUNT_EMAIL_FAILED,
  CHANGE_ACCOUNT_EMAIL_SUCCESS,
  UPDATE_USER_TOUR_CONFIG_START,
  UPDATE_USER_TOUR_CONFIG_SUCCESS,
  UPDATE_USER_TOUR_CONFIG_FAILED,
  FETCH_TYPEFORM_FORMS_START,
  FETCH_TYPEFORM_FORMS_SUCCESS,
  FETCH_TYPEFORM_FORMS_FAILED,
  FETCH_JOTFORM_FORMS_START,
  FETCH_JOTFORM_FORMS_SUCCESS,
  FETCH_JOTFORM_FORMS_FAILED,
  CREATE_JOTFORM_FORMS_START,
  CREATE_JOTFORM_FORMS_SUCCESS,
  CREATE_JOTFORM_FORMS_FAILED,
  FETCH_BRAND_LIST_START,
  FETCH_BRAND_LIST_SUCCESS,
  FETCH_BRAND_LIST_FAILED,
  CREATE_BRAND_START,
  CREATE_BRAND_SUCCESS,
  CREATE_BRAND_FAILED,
  FETCH_BRAND_DETAILS_START,
  FETCH_BRAND_DETAILS_SUCCESS,
  FETCH_BRAND_DETAILS_FAILED,
  DELETE_BRAND_START,
  DELETE_BRAND_SUCCESS,
  DELETE_BRAND_FAILED,
  UPDATE_BRAND_START,
  UPDATE_BRAND_SUCCESS,
  UPDATE_BRAND_FAILED,
  DELETE_BRAND_ASSET_START,
  DELETE_BRAND_ASSET_SUCCESS,
  DELETE_BRAND_ASSET_FAILED,
  FETCH_FACEBOOK_ALBUMS_START,
  FETCH_FACEBOOK_ALBUMS_SUCCESS,
  FETCH_FACEBOOK_ALBUMS_FAILED,
  FETCH_FACEBOOK_ALBUM_IMAGES_START,
  FETCH_FACEBOOK_ALBUM_IMAGES_SUCCESS,
  FETCH_FACEBOOK_ALBUM_IMAGES_FAILED,
  UNPUBLISH_COMPANY_TEMPLATE_START,
  UNPUBLISH_COMPANY_TEMPLATE_SUCCESS,
  UNPUBLISH_COMPANY_TEMPLATE_FAILED,
  FETCH_COMPANY_TEMPLATES_START,
  FETCH_COMPANY_TEMPLATES_SUCCESS,
  FETCH_COMPANY_TEMPLATES_FAILED,
  FETCH_COMPANY_TEMPLATE_DETAILS_START,
  FETCH_COMPANY_TEMPLATE_DETAILS_SUCCESS,
  FETCH_COMPANY_TEMPLATE_DETAILS_FAILED,
  FETCH_COMPANY_TEMPLATE_BRANDS_START,
  FETCH_COMPANY_TEMPLATE_BRANDS_SUCCESS,
  FETCH_COMPANY_TEMPLATE_BRANDS_FAILED,
  ADD_SIGNATURE_FIELD_START,
  ADD_SIGNATURE_FIELD_SUCCESS,
  ADD_SIGNATURE_FIELD_FAILED,
  GET_SIGNATURE_FORM_DETAILS_START,
  GET_SIGNATURE_FORM_DETAILS_SUCCESS,
  GET_SIGNATURE_FORM_DETAILS_FAILED,
  DELETE_SIGNATURE_FIELD_START,
  DELETE_SIGNATURE_FIELD_SUCCESS,
  DELETE_SIGNATURE_FIELD_FAILED,
  UPDATE_SIGNATURE_FIELD_START,
  UPDATE_SIGNATURE_FIELD_SUCCESS,
  UPDATE_SIGNATURE_FIELD_FAILED,
  FETCH_COMPANY_PROFILE_LIST_START,
  FETCH_COMPANY_PROFILE_LIST_SUCCESS,
  FETCH_COMPANY_PROFILE_LIST_FAILED,
  FETCH_COMPANY_PROFILE_INFO_START,
  FETCH_COMPANY_PROFILE_INFO_SUCCESS,
  FETCH_COMPANY_PROFILE_INFO_FAILED,
  CREATE_MERGE_FIELD_START,
  CREATE_MERGE_FIELD_SUCCESS,
  CREATE_MERGE_FIELD_FAILED,
  UPDATE_MERGE_FIELD_START,
  UPDATE_MERGE_FIELD_SUCCESS,
  UPDATE_MERGE_FIELD_FAILED,
  FETCH_ALL_MERGE_FIELD_START,
  FETCH_ALL_MERGE_FIELD_SUCCESS,
  FETCH_ALL_MERGE_FIELD_FAILED,
  GET_MERGE_FIELD_START,
  GET_MERGE_FIELD_SUCCESS,
  GET_MERGE_FIELD_FAILED,
  DELETE_MERGE_FIELD_START,
  DELETE_MERGE_FIELD_SUCCESS,
  DELETE_MERGE_FIELD_FAILED,
  FETCH_INTEGRATION_THIRD_PARTY_ACCOUNT_START,
  FETCH_INTEGRATION_THIRD_PARTY_ACCOUNT_SUCCESS,
  FETCH_INTEGRATION_THIRD_PARTY_ACCOUNT_FAILED,
  VALIDATE_RECORD_URL_START,
  VALIDATE_RECORD_URL_SUCCESS,
  VALIDATE_RECORD_URL_FAILED,
  FETCH_PROPOSAL_TEMPLATE_START,
  FETCH_PROPOSAL_TEMPLATE_SUCCESS,
  FETCH_PROPOSAL_TEMPLATE_FAILED,
  FETCH_INTEGRATION_START,
  FETCH_INTEGRATION_SUCCESS,
  FETCH_INTEGRATION_FAILED,
  FETCH_ZOHO_CRM_FIELDS_SCHEMA_START,
  FETCH_ZOHO_CRM_FIELDS_SCHEMA_SUCCESS,
  FETCH_ZOHO_CRM_FIELDS_SCHEMA_FAILED,
  UPDATE_REORDER_SIGNATURE_FIELD_START,
  UPDATE_REORDER_SIGNATURE_FIELD_SUCCESS,
  UPDATE_REORDER_SIGNATURE_FIELD_FAILED,
  FETCH_ZOHO_CRM_RECENTLY_MODIFIED_DEAL_START,
  FETCH_ZOHO_CRM_RECENTLY_MODIFIED_DEAL_SUCCESS,
  FETCH_ZOHO_CRM_RECENTLY_MODIFIED_DEAL_FAILED,
  SEARCH_ZOHO_CRM_DEAL_START,
  SEARCH_ZOHO_CRM_DEAL_SUCCESS,
  SEARCH_ZOHO_CRM_DEAL_FAILED
} from "./actionTypes";
import {
  userRequestManager as API,
  connectorRequestManager as connectorAPI,
  userRequestManager as templateAPI,
} from "../../_helpers/requestManager";

const companyFetchStart = () => {
  return { type: COMPANY_FETCH_START };
};
const companyFetchSuccess = result => {
  return { type: COMPANY_FETCH_SUCCESS, result };
};
const companyFetchFailed = error => {
  return { type: COMPANY_FETCH_FAILED, error };
};

const companySwitchStart = () => {
  return { type: COMPANY_SWITCH_START };
};
const companySwitchSuccess = result => {
  return { type: COMPANY_SWITCH_SUCCESS, result };
};
const companySwitchFailed = error => {
  return { type: COMPANY_SWITCH_FAILED, error };
};

const getUserListStart = () => {
  return { type: GET_USER_LIST_START };
};

const getUserListFailed = error => {
  return { type: GET_USER_LIST_FAILED, error };
};

const getUserListSuccess = (userList, total, viewType, search_key) => {
  return { type: GET_USER_LIST_SUCCESS, userList, total, viewType, search_key };
};

const activateCompanyUsersStart = () => {
  return { type: ACTIVATE_USERS_START };
};

const activateCompanyUsersFailed = data => {
  return { type: ACTIVATE_USERS_FAILED, data };
};

const activateCompanyUsersSuccess = () => {
  return { type: ACTIVATE_USERS_SUCCESS };
};

const deactivateCompanyUsersStart = () => {
  return { type: DEACTIVATE_USERS_START };
};

const deactivateCompanyUsersFailed = () => {
  return { type: DEACTIVATE_USERS_FAILED };
};

const deactivateCompanyUsersSuccess = () => {
  return { type: DEACTIVATE_USERS_SUCCESS };
};

const reinviteCompanyUsersStart = () => {
  return { type: REINVITE_USERS_START };
};

const reinviteCompanyUsersFailed = data => {
  return { type: REINVITE_USERS_FAILED, data };
};

const reinviteCompanyUsersSuccess = () => {
  return { type: REINVITE_USERS_SUCCESS };
};

const deleteCompanyUsersStart = () => {
  return { type: DELETE_USERS_START };
};

const deleteCompanyUsersFailed = data => {
  return { type: DELETE_USERS_FAILED, data };
};

const deleteCompanyUsersSuccess = () => {
  return { type: DELETE_USERS_SUCCESS };
};

const getCompanyUserInfoStart = () => {
  return { type: FETCH_COMPANY_USER_INFO_START };
};

const getCompanyUserInfoSuccess = (data, userId) => {
  return { type: FETCH_COMPANY_USER_INFO_SUCCESS, data, userId };
};

const getCompanyUserInfoFailed = () => {
  return { type: FETCH_COMPANY_USER_INFO_FAILED };
};

const createCompanyStart = () => {
  return { type: CREATE_COMPANY_START };
};
const createCompanySuccess = result => {
  return { type: CREATE_COMPANY_SUCCESS, result };
};
const createCompanyFailed = error => {
  return { type: CREATE_COMPANY_FAILED, error };
};

const getActiveCompanyUsersStart = () => {
  return { type: FETCH_ACTIVE_COMPANY_USERS_START };
};

const getActiveCompanyUsersSuccess = activeUsers => {
  return { type: FETCH_ACTIVE_COMPANY_USERS_SUCCESS, activeUsers };
};

const getActiveCompanyUsersFailed = error => {
  return { type: FETCH_ACTIVE_COMPANY_USERS_FAILED, error };
};

const getConnectedAccountsStart = () => {
  return { type: GET_CONNECTED_ACCOUNTS_START };
};
const getConnectedAccountsSuccess = result => {
  return { type: GET_CONNECTED_ACCOUNTS_SUCCESS, result };
};
const getConnectedAccountsFailed = error => {
  return { type: GET_CONNECTED_ACCOUNTS_FAILED, error };
};

const deleteConnectedAccountStart = () => {
  return { type: DELETE_CONNECTED_ACCOUNT_START };
};
const deleteConnectedAccountSuccess = (result, connectedAccountId) => {
  return { type: DELETE_CONNECTED_ACCOUNT_SUCCESS, result, connectedAccountId };
};
const deleteConnectedAccountFailed = error => {
  return { type: DELETE_CONNECTED_ACCOUNT_FAILED, error };
};

const fetchCompanyUserConfigStart = () => {
  return { type: FETCH_COMPANY_WISE_CONFIG_USER_START };
};

const fetchCompanyUserConfigSuccess = data => {
  const { slug, success, ...respData } = data;
  return { type: FETCH_COMPANY_WISE_CONFIG_USER_SUCCESS, slug, success, respData };
};

const fetchCompanyUserConfigFailed = error => {
  return { type: FETCH_COMPANY_WISE_CONFIG_USER_FAILED, error };
};

const updateCompanyUserConfigStart = () => {
  return { type: UPDATE_COMPANY_WISE_CONFIG_USER_START };
};

const updateCompanyUserConfigSuccess = (data, slug) => {
  return { type: UPDATE_COMPANY_WISE_CONFIG_USER_SUCCESS, data, slug };
};

const updateCompanyUserConfigFailed = error => {
  return { type: UPDATE_COMPANY_WISE_CONFIG_USER_FAILED, error };
};

const getCompanyInfoStart = () => {
  return { type: actionTypes.GET_COMPANY_INFO_START };
};
const getCompanyInfoSuccess = companyInfo => {
  return { type: actionTypes.GET_COMPANY_INFO_SUCCESS, companyInfo };
};
const getCompanyInfoFailed = error => {
  return { type: actionTypes.GET_COMPANY_INFO_FAILED, error };
};

const sendChangeEmailStart = () => {
  return { type: SEND_CHANGE_EMAIL_OTP_START };
};

const sendChangeEmailFailed = error => {
  return { type: SEND_CHANGE_EMAIL_OTP_FAILED, error };
};

const sendChangeEmailSuccess = data => {
  return { type: SEND_CHANGE_EMAIL_OTP_SUCCESS, data };
};

const changeAccountEmailStart = () => {
  return { type: CHANGE_ACCOUNT_EMAIL_START };
};

const changeAccountEmailFailed = error => {
  return { type: CHANGE_ACCOUNT_EMAIL_FAILED, error };
};

const changeAccountEmailSuccess = data => {
  return { type: CHANGE_ACCOUNT_EMAIL_SUCCESS, data };
};

const updateTourConfigStart = () => {
  return { type: UPDATE_USER_TOUR_CONFIG_START };
};

const updateTourConfigFailed = error => {
  return { type: UPDATE_USER_TOUR_CONFIG_FAILED, error };
};

const updateTourConfigSuccess = data => {
  return { type: UPDATE_USER_TOUR_CONFIG_SUCCESS, data };
};

const fetchTypeformFormsStart = () => {
  return { type: FETCH_TYPEFORM_FORMS_START };
};

const fetchTypeformFormsFailed = error => {
  return { type: FETCH_TYPEFORM_FORMS_FAILED, error };
};

const fetchTypeformFormsSuccess = (data, assetName) => {
  let forms = data?.details;
  return { type: FETCH_TYPEFORM_FORMS_SUCCESS, forms, assetName };
};

const fetchJotformFormsStart = () => {
  return { type: FETCH_JOTFORM_FORMS_START };
};

const fetchJotformFormsSuccess = results => {
  return { type: FETCH_JOTFORM_FORMS_SUCCESS, results };
};

const fetchJotformFormsFailed = error => {
  return { type: FETCH_JOTFORM_FORMS_FAILED, error };
};

const connectJotformFormsStart = () => {
  return { type: CREATE_JOTFORM_FORMS_START };
};

const connectJotformFormsSuccess = results => {
  return { type: CREATE_JOTFORM_FORMS_SUCCESS, results };
};

const connectJotformFormsFailed = error => {
  return { type: CREATE_JOTFORM_FORMS_FAILED, error };
};

const fetchBrandListStart = () => {
  return { type: FETCH_BRAND_LIST_START };
};

const fetchBrandListSuccess = results => {
  return { type: FETCH_BRAND_LIST_SUCCESS, results };
};

const fetchBrandListFailed = error => {
  return { type: FETCH_BRAND_LIST_FAILED, error };
};

const createBrandStart = () => {
  return { type: CREATE_BRAND_START };
};

const createBrandSuccess = results => {
  return { type: CREATE_BRAND_SUCCESS, results };
};

const createBrandFailed = error => {
  return { type: CREATE_BRAND_FAILED, error };
};

const fetchBrandInfoStart = () => {
  return { type: FETCH_BRAND_DETAILS_START };
};

const fetchBrandInfoSuccess = brandInfo => {
  return { type: FETCH_BRAND_DETAILS_SUCCESS, brandInfo };
};

const fetchBrandInfoFailed = error => {
  return { type: FETCH_BRAND_DETAILS_FAILED, error };
};

const deleteBrandStart = () => {
  return { type: DELETE_BRAND_START };
};

const deleteBrandSuccess = data => {
  return { type: DELETE_BRAND_SUCCESS, data };
};

const deleteBrandFailed = error => {
  return { type: DELETE_BRAND_FAILED, error };
};

const updateBrandStart = () => {
  return { type: UPDATE_BRAND_START };
};

const updateBrandSuccess = (data, hashkey) => {
  return { type: UPDATE_BRAND_SUCCESS, data, hashkey };
};

const updateBrandFailed = error => {
  return { type: UPDATE_BRAND_FAILED, error };
};

const deleteBrandAssetStart = () => {
  return { type: DELETE_BRAND_ASSET_START };
};

const deleteBrandAssetSuccess = (data, assetId) => {
  return { type: DELETE_BRAND_ASSET_SUCCESS, data, assetId };
};

const deleteBrandAssetFailed = error => {
  return { type: DELETE_BRAND_ASSET_FAILED, error };
};

const fetchFacebookAlbumsStart = () => {
  return { type: FETCH_FACEBOOK_ALBUMS_START };
};

const fetchFacebookAlbumsSuccess = data => {
  return { type: FETCH_FACEBOOK_ALBUMS_SUCCESS, data };
};

const fetchFacebookAlbumsFailed = error => {
  return { type: FETCH_FACEBOOK_ALBUMS_FAILED, error };
};

const fetchFacebookAlbumImagesStart = () => {
  return { type: FETCH_FACEBOOK_ALBUM_IMAGES_START };
};

const fetchFacebookAlbumImagesSuccess = (data, albumId) => {
  return { type: FETCH_FACEBOOK_ALBUM_IMAGES_SUCCESS, data, albumId };
};

const fetchFacebookAlbumImagesFailed = error => {
  return { type: FETCH_FACEBOOK_ALBUM_IMAGES_FAILED, error };
};

const unpublishCompanyTemplateStart = () => {
  return { type: UNPUBLISH_COMPANY_TEMPLATE_START };
};

const unpublishCompanyTemplateSuccess = result => {
  return { type: UNPUBLISH_COMPANY_TEMPLATE_SUCCESS, result };
};

const unpublishCompanyTemplateFailed = error => {
  return { type: UNPUBLISH_COMPANY_TEMPLATE_FAILED, error };
};

const fetchCompanyTemplatesStart = () => {
  return { type: FETCH_COMPANY_TEMPLATES_START };
};

const fetchCompanyTemplatesSuccess = result => {
  return { type: FETCH_COMPANY_TEMPLATES_SUCCESS, result };
};

const fetchCompanyTemplatesFailed = error => {
  return { type: FETCH_COMPANY_TEMPLATES_FAILED, error };
};

const fetchCompanyTemplateDetailsStart = () => {
  return { type: FETCH_COMPANY_TEMPLATE_DETAILS_START };
};

const fetchCompanyTemplateDetailsSuccess = result => {
  return { type: FETCH_COMPANY_TEMPLATE_DETAILS_SUCCESS, result };
};

const fetchCompanyTemplateDetailsFailed = error => {
  return { type: FETCH_COMPANY_TEMPLATE_DETAILS_FAILED, error };
};

const fetchCompanyTemplateBrandsStart = () => {
  return { type: FETCH_COMPANY_TEMPLATE_BRANDS_START };
};

const fetchCompanyTemplateBrandsSuccess = result => {
  return { type: FETCH_COMPANY_TEMPLATE_BRANDS_SUCCESS, result };
};

const fetchCompanyTemplateBrandsFailed = error => {
  return { type: FETCH_COMPANY_TEMPLATE_BRANDS_FAILED, error };
};

const getCompanyPublicConfigStart = () => {
  return { type: actionTypes.GET_COMPANY_PUBLIC_CONFIG_START };
};
const getCompanyPublicConfigSuccess = companyInfo => {
  return { type: actionTypes.GET_COMPANY_PUBLIC_CONFIG_SUCCESS, companyInfo };
};
const getCompanyPublicConfigFailed = error => {
  return { type: actionTypes.GET_COMPANY_PUBLIC_CONFIG_FAILED, error };
};

const fetchProposalModuleListStart = () => {
  return { type: actionTypes.FETCH_PROPOSAL_MODULE_LIST_START };
};

const fetchProposalModuleListSuccess = (results, module) => {
  return { type: actionTypes.FETCH_PROPOSAL_MODULE_LIST_SUCCESS, results, module };
};

const fetchProposalModuleListFailed = error => {
  return { type: actionTypes.FETCH_PROPOSAL_MODULE_LIST_FAILED, error };
};

const createProposalModuleRecordStart = () => {
  return { type: actionTypes.CREATE_PROPOSAL_MODULE_RECORD_START };
};

const createProposalModuleRecordSuccess = data => {
  return { type: actionTypes.CREATE_PROPOSAL_MODULE_RECORD_SUCCESS, data };
};

const createProposalModuleRecordFailed = error => {
  return { type: actionTypes.CREATE_PROPOSAL_MODULE_RECORD_FAILED, error };
};

const updateProposalModuleRecordStart = () => {
  return { type: actionTypes.UPDATE_PROPOSAL_MODULE_RECORD_START };
};

const updateProposalModuleRecordSuccess = data => {
  return { type: actionTypes.UPDATE_PROPOSAL_MODULE_RECORD_SUCCESS, data };
};

const updateProposalModuleRecordFailed = error => {
  return { type: actionTypes.UPDATE_PROPOSAL_MODULE_RECORD_FAILED, error };
};

const deleteProposalModuleRecordStart = () => {
  return { type: actionTypes.DELETE_PROPOSAL_MODULE_RECORD_START };
};

const deleteProposalModuleRecordSuccess = data => {
  return { type: actionTypes.DELETE_PROPOSAL_MODULE_RECORD_SUCCESS, data };
};

const deleteProposalModuleRecordFailed = error => {
  return { type: actionTypes.DELETE_PROPOSAL_MODULE_RECORD_FAILED, error };
};

const addSignatureFieldStart = () => {
  return { type: ADD_SIGNATURE_FIELD_START };
};

const addSignatureFieldSuccess = result => {
  return { type: ADD_SIGNATURE_FIELD_SUCCESS, result };
};

const addSignatureFieldFailed = error => {
  return { type: ADD_SIGNATURE_FIELD_FAILED, error };
};

const getSignatureFormDetailsStart = () => {
  return { type: GET_SIGNATURE_FORM_DETAILS_START };
};

const getSignatureFormDetailsSuccess = result => {
  return { type: GET_SIGNATURE_FORM_DETAILS_SUCCESS, result };
};

const getSignatureFormDetailsFailed = error => {
  return { type: GET_SIGNATURE_FORM_DETAILS_FAILED, error };
};

const deleteSignatureFieldStart = () => {
  return { type: DELETE_SIGNATURE_FIELD_START };
};

const deleteSignatureFieldSuccess = result => {
  return { type: DELETE_SIGNATURE_FIELD_SUCCESS, result };
};

const deleteSignatureFieldFailed = error => {
  return { type: DELETE_SIGNATURE_FIELD_FAILED, error };
};

const updateSignatureFieldStart = () => {
  return { type: UPDATE_SIGNATURE_FIELD_START };
};

const updateSignatureFieldSuccess = result => {
  return { type: UPDATE_SIGNATURE_FIELD_SUCCESS, result };
};

const updateSignatureFieldFailed = error => {
  return { type: UPDATE_SIGNATURE_FIELD_FAILED, error };
};

const getCompanyProfileListStart = () => {
  return { type: FETCH_COMPANY_PROFILE_LIST_START };
};

const getCompanyProfileListSuccess = profiles => {
  return { type: FETCH_COMPANY_PROFILE_LIST_SUCCESS, profiles };
};

const getCompanyProfileListFailed = error => {
  return { type: FETCH_COMPANY_PROFILE_LIST_FAILED, error };
};

const getCompanyProfileInfoStart = () => {
  return { type: FETCH_COMPANY_PROFILE_INFO_START };
};

const getCompanyProfileInfoSuccess = profileInfo => {
  let permissions = profileInfo?.data;
  return { type: FETCH_COMPANY_PROFILE_INFO_SUCCESS, permissions };
};

const getCompanyProfileInfoFailed = error => {
  return { type: FETCH_COMPANY_PROFILE_INFO_FAILED, error };
};

const createMergeFieldStart = () => {
  return { type: CREATE_MERGE_FIELD_START };
};

const createMergeFieldSuccess = result => {
  return { type: CREATE_MERGE_FIELD_SUCCESS, result };
};

const createMergeFieldFailed = error => {
  return { type: CREATE_MERGE_FIELD_FAILED, error };
};

const updateMergeFieldStart = () => {
  return { type: UPDATE_MERGE_FIELD_START };
};

const updateMergeFieldSuccess = result => {
  return { type: UPDATE_MERGE_FIELD_SUCCESS, result };
};

const updateMergeFieldFailed = error => {
  return { type: UPDATE_MERGE_FIELD_FAILED, error };
};

const fetchAllMergeFieldStart = () => {
  return { type: FETCH_ALL_MERGE_FIELD_START };
};

const fetchAllMergeFieldSuccess = result => {
  return { type: FETCH_ALL_MERGE_FIELD_SUCCESS, result };
};

const fetchAllMergeFieldFailed = error => {
  return { type: FETCH_ALL_MERGE_FIELD_FAILED, error };
};

const getMergeFieldStart = () => {
  return { type: GET_MERGE_FIELD_START };
};

const getMergeFieldSuccess = result => {
  return { type: GET_MERGE_FIELD_SUCCESS, result };
};

const getMergeFieldFailed = error => {
  return { type: GET_MERGE_FIELD_FAILED, error };
};

const deleteMergeFieldStart = () => {
  return { type: DELETE_MERGE_FIELD_START };
};

const deleteMergeFieldSuccess = result => {
  return { type: DELETE_MERGE_FIELD_SUCCESS, result };
};

const deleteMergeFieldFailed = error => {
  return { type: DELETE_MERGE_FIELD_FAILED, error };
};

const fetchCollectionSpecificConfigStart = () => {
  return { type: actionTypes.FETCH_COLLECTION_SPECIFIC_CONFIG_START };
};

const fetchCollectionSpecificConfigSuccess = (data, slugKey) => {
  const { slug, success, ...respData } = data;
  return { type: actionTypes.FETCH_COLLECTION_SPECIFIC_CONFIG_SUCCESS, slug, success, respData, slugKey };
};

const fetchCollectionSpecificConfigFailed = error => {
  return { type: actionTypes.FETCH_COLLECTION_SPECIFIC_CONFIG_FAILED, error };
};

const updateReorderSignatureFieldStart = () => {
  return { type: UPDATE_REORDER_SIGNATURE_FIELD_START };
};

const updateReorderSignatureFieldSuccess = result => {
  return { type: UPDATE_REORDER_SIGNATURE_FIELD_SUCCESS, result };
};

const updateReorderSignatureFieldFailed = error => {
  return { type: UPDATE_REORDER_SIGNATURE_FIELD_FAILED, error };
};

const fetchIntegrationThirdPartyAccountStart = () => {
  return { type: FETCH_INTEGRATION_THIRD_PARTY_ACCOUNT_START };
};

const fetchIntegrationThirdPartyAccountSuccess = result => {
  return { type: FETCH_INTEGRATION_THIRD_PARTY_ACCOUNT_SUCCESS, result };
};

const fetchIntegrationThirdPartyAccountFailed = error => {
  return { type: FETCH_INTEGRATION_THIRD_PARTY_ACCOUNT_FAILED, error };
};

const validateRecordUrlLinkStart = () => {
  return { type: VALIDATE_RECORD_URL_START };
};

const validateRecordUrlLinkSuccess = result => {
  return { type: VALIDATE_RECORD_URL_SUCCESS, result };
};

const validateRecordUrlLinkFailed = error => {
  return { type: VALIDATE_RECORD_URL_FAILED, error };
};

const fetchProposalTemplateStart = () => {
  return { type: FETCH_PROPOSAL_TEMPLATE_START };
};

const fetchProposalTemplateSuccess = result => {
  return { type: FETCH_PROPOSAL_TEMPLATE_SUCCESS, result };
};

const fetchProposalTemplateFailed = error => {
  return { type: FETCH_PROPOSAL_TEMPLATE_FAILED, error };
};

const fetchIntegrationsStart = () => {
  return { type: FETCH_INTEGRATION_START };
};

const fetchIntegrationsSuccess = result => {
  return { type: FETCH_INTEGRATION_SUCCESS, result };
};

const fetchIntegrationsFailed = error => {
  return { type: FETCH_INTEGRATION_FAILED, error };
};

export const fetchCompany = () => {
  return dispatch => {
    dispatch(companyFetchStart());

    return API.get("/companies")
      .then(r => dispatch(companyFetchSuccess(r.data)))
      .catch(e => dispatch(companyFetchFailed(e)));
  };
};

export const switchCompany = companyId => {
  let endPoint = `/companies/${companyId}/switch`;

  return dispatch => {
    dispatch(companySwitchStart());

    return API.post(endPoint)
      .then(r => dispatch(companySwitchSuccess(r.data)))
      .catch(e => dispatch(companySwitchFailed(e)));
  };
};

// Get company users
export const getUserList = payload => {
  let page = payload?.page ?? 1;
  let limit = payload?.limit ?? 50;
  let view = payload?.view ?? "ALL";
  let search_key = payload?.search_key ? true : false;

  let queryParams = `page=${page}&limit=${limit}&view=${view}`;

  if (payload?.search_key?.length > 0) {
    queryParams = `page=${page}&limit=${limit}&view=${view}&search_key=${payload?.search_key}`;
  }

  return dispatch => {
    dispatch(getUserListStart());
    return API.get(`/list?${queryParams}`)
      .then(r => dispatch(getUserListSuccess(r.data?.users, r.data?.total, view, search_key)))
      .catch(e => dispatch(getUserListFailed(e)));
  };
};

// Activate company users
export const activateCompanyUsers = payload => {
  return dispatch => {
    dispatch(activateCompanyUsersStart());
    return API.post(`/activate`, payload)
      .then(r => {
        if (r.data.success) dispatch(activateCompanyUsersSuccess(r.data));
        else dispatch(activateCompanyUsersFailed(r.data));
      })
      .catch(e => dispatch(activateCompanyUsersFailed(e.response.data)));
  };
};

// Deactivate company users
export const deactivateCompanyUsers = (payload, notify = false) => {
  return dispatch => {
    dispatch(deactivateCompanyUsersStart());
    return API.post(`/deactivate?notify=${notify}`, payload)
      .then(r => {
        if (r.data.success) dispatch(deactivateCompanyUsersSuccess(r.data));
        else dispatch(deactivateCompanyUsersFailed(r.data));
      })
      .catch(e => dispatch(deactivateCompanyUsersFailed(e)));
  };
};

// Reinvite company users
export const reinviteCompanyUsers = (payload, re_invite = false) => {
  return dispatch => {
    dispatch(reinviteCompanyUsersStart());
    return API.post(`/invite?re_invite=${re_invite}`, payload)
      .then(r => {
        if (r.data.success) dispatch(reinviteCompanyUsersSuccess(r.data));
        else dispatch(reinviteCompanyUsersFailed(r.data));
      })
      .catch(e => dispatch(reinviteCompanyUsersFailed(e.response.data)));
  };
};

// Delete company users
export const deleteCompanyUsers = (payload, change_ownership = false, collection = false) => {
  const endpoint = change_ownership
  ? `/delete-user?change_ownership=${change_ownership}${collection ? "&collection=true" : ""}`
  : "/delete-user";
  return dispatch => {
    dispatch(deleteCompanyUsersStart());
    return API.delete(endpoint, { data: payload })
      .then(r => {
        if (r.data.success) dispatch(deleteCompanyUsersSuccess(r.data));
        else dispatch(deleteCompanyUsersFailed(r.data));
      })
      .catch(e => dispatch(deleteCompanyUsersFailed(e)));
  };
};

// Get company user info
export const getCompanyUserInfo = userId => {
  return dispatch => {
    dispatch(getCompanyUserInfoStart());
    return API.get(`/${userId}`)
      .then(r => {
        r.data.name = [r.data?.firstname, r.data?.middlename, r.data?.lastname].join(" ").replace(/\s+/g, " ").trim();
        dispatch(getCompanyUserInfoSuccess(r.data, userId));
      })
      .catch(e => dispatch(getCompanyUserInfoFailed(e)));
  };
};

export const createCompany = payload => {
  return dispatch => {
    dispatch(createCompanyStart());

    return API.post("/user-company", payload)
      .then(r => dispatch(createCompanySuccess(r.data)))
      .catch(e => dispatch(createCompanyFailed(e)));
  };
};

// Get All actice company users
export const getActiveUserList = () => {
  let page = 1;
  let limit = 50;
  let view = "JOINED";
  let queryParams = `page=${page}&limit=${limit}&view=${view}`;
  return dispatch => {
    dispatch(getActiveCompanyUsersStart());
    return API.get(`/list?${queryParams}`)
      .then(r => dispatch(getActiveCompanyUsersSuccess(r.data?.users)))
      .catch(e => dispatch(getActiveCompanyUsersFailed(e)));
  };
};

export const getConnectedAccounts = () => {
  return dispatch => {
    dispatch(getConnectedAccountsStart());
    return connectorAPI
      .get("/")
      .then(r => dispatch(getConnectedAccountsSuccess(r.data)))
      .catch(e => dispatch(getConnectedAccountsFailed(e)));
  };
};

export const deleteConnectedAccount = connectedAccountId => {
  return dispatch => {
    dispatch(deleteConnectedAccountStart());
    return connectorAPI
      .delete(`/${connectedAccountId}`)
      .then(r => dispatch(deleteConnectedAccountSuccess(r.data, connectedAccountId)))
      .catch(e => dispatch(deleteConnectedAccountFailed(e)));
  };
};

export const getCompanyInfo = company_id => {
  return dispatch => {
    dispatch(getCompanyInfoStart());
    return API.get(`/companies/${company_id}`)
      .then(r => {
        dispatch(getCompanyInfoSuccess(r.data.data));
      })
      .catch(e => dispatch(getCompanyInfoFailed(e)));
  };
};

export const fetchCompanyUserConfig = slug => {
  return dispatch => {
    dispatch(fetchCompanyUserConfigStart());
    return API.get(`/${slug}/config`)
      .then(r => dispatch(fetchCompanyUserConfigSuccess(r.data)))
      .catch(e => dispatch(fetchCompanyUserConfigFailed(e)));
  };
};

export const updateCompanyUserConfig = (payload = {}) => {
  return dispatch => {
    dispatch(updateCompanyUserConfigStart());
    return API.put(`/config/update`, payload)
      .then(r => dispatch(updateCompanyUserConfigSuccess(r.data, payload.slug)))
      .catch(e => dispatch(updateCompanyUserConfigFailed(e)));
  };
};

export const sendChangeEmailOTP = (payload = {}) => {
  return dispatch => {
    dispatch(sendChangeEmailStart());
    return API.post("/change-email/send-otp", payload)
      .then(r => {
        if (r.data.success) {
          dispatch(sendChangeEmailSuccess(r.data));
        } else {
          dispatch(sendChangeEmailFailed(r.data));
        }
      })
      .catch(err => dispatch(sendChangeEmailFailed(err.response.data)));
  };
};

export const changeAccountEmail = (payload = {}) => {
  return dispatch => {
    dispatch(changeAccountEmailStart());
    return API.post("/change-email/validate-otp", payload)
      .then(r => {
        if (r.data.success) {
          dispatch(changeAccountEmailSuccess(r.data));
        } else {
          dispatch(changeAccountEmailFailed(r.data));
        }
      })
      .catch(err => dispatch(changeAccountEmailFailed(err.response.data)));
  };
};

// User Tour data update:
export const updateUserTourConfig = (userId, payload = {}) => {
  return dispatch => {
    dispatch(updateTourConfigStart());
    return API.put(`/${userId}/tour`, payload)
      .then(() => dispatch(updateTourConfigSuccess(payload)))
      .catch(e => dispatch(updateTourConfigFailed(e)));
  };
};

export const fetchTypeformForms = assetName => {
  return dispatch => {
    // dispatch(fetchTypeformFormsStart());
    return connectorAPI.get(`/forms/typeform`);
    // .then(r => dispatch(fetchTypeformFormsSuccess(r.data, assetName)))
    // .catch(e => dispatch(fetchTypeformFormsFailed(e)));
  };
};

//jotform
export const fetchJotformForms = () => {
  return dispatch => {
    // dispatch(fetchJotformFormsStart());
    return connectorAPI.get(`/forms/jotform`);
    // .then(r => dispatch(fetchJotformFormsSuccess(r.data)))
    // .catch(e => dispatch(fetchJotformFormsFailed(e)));
  };
};

export const connectJotformForms = apiKey => {
  const payload = {
    api_key: apiKey,
    provider: "jotform",
    provider_label: "Jotform"
  };
  return dispatch => {
    dispatch(connectJotformFormsStart());
    return connectorAPI
      .post(`/forms/jotform`, payload)
      .then(r => dispatch(connectJotformFormsSuccess(r.data)))
      .catch(e => dispatch(connectJotformFormsFailed(e)));
  };
};

// Create Company Brand
export const createBrand = brandName => {
  return dispatch => {
    dispatch(createBrandStart());

    return API.post("/company/brands", brandName)
      .then(r => dispatch(createBrandSuccess(r.data)))
      .catch(e => dispatch(createBrandFailed(e)));
  };
};

// Fetch company brands
export const fetchBrands = payload => {
  let page = payload?.page ?? 1;
  let limit = payload?.limit ?? 50;
  const endPoint = `/company/brands?page=${page}&limit=${limit}`;

  return dispatch => {
    dispatch(fetchBrandListStart());

    return API.get(endPoint)
      .then(r => dispatch(fetchBrandListSuccess(r.data)))
      .catch(e => dispatch(fetchBrandListFailed(e)));
  };
};

// Fetch company brand details
export const fetchBrandDetils = brandId => {
  return dispatch => {
    dispatch(fetchBrandInfoStart());

    return API.get(`/company/brands/${brandId}`)
      .then(r => dispatch(fetchBrandInfoSuccess(r.data)))
      .catch(e => dispatch(fetchBrandInfoFailed(e)));
  };
};

// Create Company Brand
export const deleteBrand = (brandIds = []) => {
  return dispatch => {
    dispatch(deleteBrandStart());

    return API.post(`/company/brands/delete`, {
      deletedItemList: brandIds,
    })
      .then(r => dispatch(deleteBrandSuccess(r.data)))
      .catch(e => dispatch(deleteBrandFailed(e)));
  };
};

// Update Brand Info
export const updateBrand = (brandInfo, brandId, hashkey) => {
  return dispatch => {
    dispatch(updateBrandStart());

    return API.put(`/company/brands/${brandId}/update`, brandInfo)
      .then(r => dispatch(updateBrandSuccess(r.data, hashkey)))
      .catch(e => dispatch(updateBrandFailed(e)));
  };
};

// Delete Brand Asset
export const deleteBrandAsset = (brandId, assetType, assetId) => {
  return dispatch => {
    dispatch(deleteBrandAssetStart());

    return API.delete(`/company/brands/${brandId}/${assetType}/${assetId}`)
      .then(r => dispatch(deleteBrandAssetSuccess(r.data, assetId)))
      .catch(e => dispatch(deleteBrandAssetFailed(e)));
  };
};

// Fetch Facebook albums and images
export const fetchFacebookAlbums = () => {
  return dispatch => {
    dispatch(fetchFacebookAlbumsStart());
    return connectorAPI
      .get(`/facebook/albums`)
      .then(r => dispatch(fetchFacebookAlbumsSuccess(r.data)))
      .catch(e => dispatch(fetchFacebookAlbumsFailed(e)));
  };
};

export const fetchFacebookAlbumImages = payload => {
  let { albumId, page, limit } = payload;
  let url = `/facebook/album/images?album_id=${albumId}&limit=${limit}`;

  // Include page parameter in the URL if it's present in the payload
  if (page !== undefined && page !== null) {
    url += `&page=${page}`;
  }
  return dispatch => {
    dispatch(fetchFacebookAlbumImagesStart());
    return connectorAPI
      .get(url)
      .then(r => dispatch(fetchFacebookAlbumImagesSuccess(r.data, albumId)))
      .catch(e => dispatch(fetchFacebookAlbumImagesFailed(e)));
  };
};

// company templates
export const unpublishCompanyTemplate = templateId => {
  return dispatch => {
    dispatch(unpublishCompanyTemplateStart());

    return API.put(`/company/templates/${templateId}/unpublish`)
      .then(r => dispatch(unpublishCompanyTemplateSuccess(r.data)))
      .catch(e => dispatch(unpublishCompanyTemplateFailed(e)));
  };
};

export const fetchCompanyTemplates = ({ page = 1, limit = 25, brandId }) => {
  const brandQuery = brandId != "all" ? `&brand=${brandId}` : "";

  return dispatch => {
    dispatch(fetchCompanyTemplatesStart());

    return API.get(`/company/templates?page=${page}&limit=${limit}${brandQuery}`)
      .then(r => dispatch(fetchCompanyTemplatesSuccess(r.data)))
      .catch(e => dispatch(fetchCompanyTemplatesFailed(e)));
  };
};

export const fetchCompanyTemplateDetails = templateId => {
  return dispatch => {
    dispatch(fetchCompanyTemplateDetailsStart());

    return API.get(`/company/templates/${templateId}`)
      .then(r => dispatch(fetchCompanyTemplateDetailsSuccess(r.data)))
      .catch(e => dispatch(fetchCompanyTemplateDetailsFailed(e)));
  };
};

export const fetchCompanyTemplateBrands = () => {
  return dispatch => {
    dispatch(fetchCompanyTemplateBrandsStart());

    return API.get(`/company/templates/publish/brands`)
      .then(r => dispatch(fetchCompanyTemplateBrandsSuccess(r.data)))
      .catch(e => dispatch(fetchCompanyTemplateBrandsFailed(e)));
  };
};

export const getCompanyPublicConfig = company_id => {
  return dispatch => {
    dispatch(getCompanyPublicConfigStart());

    return API.get(`/companies/${company_id}/public/config`, {
      headers: {
        "X-Auth": "NoAuth",
      },
    })
      .then(r => dispatch(getCompanyPublicConfigSuccess(r.data)))
      .catch(e => dispatch(getCompanyPublicConfigFailed(e)));
  };
};

// Fetch company Proposal Module List
export const fetchProposalModuleList = (module, payload) => {
  let page = payload?.page ?? 1;
  let limit = payload?.limit ?? 25;
  let search_key = payload?.search_key ? true : false;
  let endPoint = `/proposal/settings?module=${module}&page=${page}&limit=${limit}`;

  // Add 'search_key' if it exists
  if (search_key && payload?.search_key?.length > 0) {
    endPoint += `&keyword=${payload.search_key}`;
  }
  return dispatch => {
    dispatch(fetchProposalModuleListStart());

    return API.get(endPoint)
      .then(r => dispatch(fetchProposalModuleListSuccess(r.data, module)))
      .catch(e => dispatch(fetchProposalModuleListFailed(e)));
  };
};

// Create Company Proposal Module Record
export const createProposalModuleRecord = (module, payload) => {
  return dispatch => {
    dispatch(createProposalModuleRecordStart());
    return API.post(`/proposal/settings?module=${module}`, payload)
      .then(r => dispatch(createProposalModuleRecordSuccess(r.data)))
      .catch(e => dispatch(createProposalModuleRecordFailed(e)));
  };
};

// Update Company Proposal Module Record
export const updateProposalModuleRecord = (module, recordId, payload) => {
  return dispatch => {
    dispatch(updateProposalModuleRecordStart());
    return API.put(`/proposal/settings/${recordId}?module=${module}`, payload)
      .then(r => dispatch(updateProposalModuleRecordSuccess(r.data)))
      .catch(e => dispatch(updateProposalModuleRecordFailed(e)));
  };
};

// Delete Company Proposal Module Record
export const deleteProposalModuleRecord = (module, recordId) => {
  return dispatch => {
    dispatch(deleteProposalModuleRecordStart());

    return API.delete(`/proposal/settings/${recordId}?module=${module}`)
      .then(r => dispatch(deleteProposalModuleRecordSuccess(r.data)))
      .catch(e => dispatch(deleteProposalModuleRecordFailed(e)));
  };
};

// Create Company Proposal Items Module Record
export const createProposalItemsModuleRecord = payload => {
  return dispatch => {
    return API.post(`/proposal/items`, payload);
  };
};

// Fetch company Proposal item details
export const fetchProposalItemDetails = (recordId, module) => {
  const endPoint = `/proposal/settings/${recordId}?module=${module}`;
  return dispatch => {
    return API.get(endPoint);
  };
};

// Update Company Proposal Module Record
export const updateProposalItemModuleRecord = (recordId, payload) => {
  return dispatch => {
    return API.put(`/proposal/items/${recordId}`, payload);
  };
};

// Delete Company Proposal Item Image
export const deleteProposalModuleItemImage = (recordId, imageIndex) => {
  return dispatch => {
    return API.delete(`/proposal/items/${recordId}/images/${imageIndex}/delete`);
  };
};
//signature forms
export const addSignatureFormField = (form_id, payload) => {
  return dispatch => {
    dispatch(addSignatureFieldStart());
    return API.put(`/proposal/signature-forms/${form_id}/add-field`, payload)
      .then(r => dispatch(addSignatureFieldSuccess(r.data)))
      .catch(e => dispatch(addSignatureFieldFailed(e)));
  };
};

export const fetchSignatureFormDetails = (module, form_id) => {
  return dispatch => {
    dispatch(getSignatureFormDetailsStart());
    return API.get(`/proposal/settings/${form_id}?module=${module}`)
      .then(r => dispatch(getSignatureFormDetailsSuccess(r.data)))
      .catch(e => dispatch(getSignatureFormDetailsFailed(e)));
  };
};

export const deleteSignatureField = (form_id, field_id) => {
  return dispatch => {
    dispatch(deleteSignatureFieldStart());
    return API.put(`/proposal/signature-forms/${form_id}/remove-field/${field_id}`)
      .then(r => dispatch(deleteSignatureFieldSuccess(r.data)))
      .catch(e => dispatch(deleteSignatureFieldFailed(e)));
  };
};

export const updateSignatureField = (form_id, field_id, payload) => {
  return dispatch => {
    dispatch(updateSignatureFieldStart());
    return API.put(`/proposal/signature-forms/${form_id}/edit-field/${field_id}`, payload)
      .then(r => dispatch(updateSignatureFieldSuccess(r.data)))
      .catch(e => dispatch(updateSignatureFieldFailed(e)));
  };
};

// Fetch company Proposal Item List
export const fetchProposalItems = payload => {
  let page = payload?.page ?? 1;
  let limit = payload?.limit ?? 25;
  const endPoint = `/proposal/items/list`;

  return dispatch => {
    return API.get(endPoint);
  };
};

export const getCompanyProfileList = () => {
  return dispatch => {
    dispatch(getCompanyProfileListStart());

    return API.get(`/companies/member/profile/list`)
      .then(r => dispatch(getCompanyProfileListSuccess(r.data)))
      .catch(e => dispatch(getCompanyProfileListFailed(e)));
  };
};

export const getCompanyProfileInfo = profileId => {
  return dispatch => {
    dispatch(getCompanyProfileInfoStart());

    return API.get(`/companies/member/profile/${profileId}`)
      .then(r => dispatch(getCompanyProfileInfoSuccess(r.data)))
      .catch(e => dispatch(getCompanyProfileInfoFailed(e)));
  };
};

export const updateUserProfileInfo = (memberId, payload = {}) => {
  return dispatch => {
    return API.put(`/companies/member/${memberId}/profile`, payload);
  };
};

//Custom Merge Field
export const addMergeField = (company_id, payload) => {
  return dispatch => {
    dispatch(createMergeFieldStart());
    return API.post(`/companies/${company_id}/merge-fields`, payload)
      .then(r => dispatch(createMergeFieldSuccess(r.data)))
      .catch(e => dispatch(createMergeFieldFailed(e)));
  };
};

export const updateMergeField = (company_id, field_id, payload) => {
  return dispatch => {
    dispatch(updateMergeFieldStart());
    return API.put(`/companies/${company_id}/merge-fields/${field_id}`, payload)
      .then(r => dispatch(updateMergeFieldSuccess(r.data)))
      .catch(e => dispatch(updateMergeFieldFailed(e)));
  };
};

export const fetchAllMergeField = (company_id, payload, source = "custom") => {
  let { page = 1, limit = 25 } = payload || {};
  return dispatch => {
    dispatch(fetchAllMergeFieldStart());
    return API.get(`/companies/${company_id}/merge-fields?page=${page}&limit=${limit}&source=${source}`)
      .then(r => dispatch(fetchAllMergeFieldSuccess(r.data)))
      .catch(e => dispatch(fetchAllMergeFieldFailed(e)));
  };
};

export const fetchSingleMergeField = (form_id, payload) => {
  return dispatch => {
    dispatch(getMergeFieldStart());
    return API.put(`/proposal/signature-forms/${form_id}/add-field`, payload)
      .then(r => dispatch(getMergeFieldSuccess(r.data)))
      .catch(e => dispatch(getMergeFieldFailed(e)));
  };
};

export const deleteMergeField = (company_id, field_id) => {
  return dispatch => {
    dispatch(deleteMergeFieldStart());
    return API.delete(`/companies/${company_id}/merge-fields/${field_id}`)
      .then(r => dispatch(deleteMergeFieldSuccess(r.data)))
      .catch(e => dispatch(deleteMergeFieldFailed(e)));
  };
};

// Mark Proposal Module Records as used
export const markProposaModuleRecordsAsUsed = (module, payload) => {
  return dispatch => {
    return API.put(`/proposal/settings/mark-used?module=${module}`, payload);
  };
};

// Fetch Proposal Module
export const fetchProposalModule = (module, payload) => {
  let page = payload?.page ?? 1;
  let limit = payload?.limit ?? 25;
  const endPoint = `/proposal/settings?module=${module}&page=${page}&limit=${limit}`;
  return dispatch => {
    return API.get(endPoint);
  };
};

// Fetch company Proposal Item List
export const fetchProposalItemsList = () => {
  const endPoint = `/proposal/items/list`;
  return dispatch => {
    return API.get(endPoint);
  };
};

// Third party account fetch (CRM)
export const fetchThirdPartyAccount = companyId => {
  return dispatch => {
    dispatch(fetchIntegrationThirdPartyAccountStart());
    return connectorAPI
      .get(`/${companyId}/accounts?group=crm`)
      .then(r => dispatch(fetchIntegrationThirdPartyAccountSuccess(r.data)))
      .catch(e => dispatch(fetchIntegrationThirdPartyAccountFailed(e)));
  };
};

export const validateRecordUrl = link => {
  return dispatch => {
    dispatch(validateRecordUrlLinkStart());
    return connectorAPI
      .get(`/${link}`)
      .then(r => dispatch(validateRecordUrlLinkSuccess(r.data)))
      .catch(e => dispatch(validateRecordUrlLinkFailed(e)));
  };
};

export const fetchPropsalTemplateType = (proposalId, payloadFetch, provider) => {
  return dispatch => {
    dispatch(fetchProposalTemplateStart());
    return templateAPI
      .get(`/company/templates?page=${payloadFetch.page}&limit=${payloadFetch.limit}&template_type=${proposalId}&data_source=${provider}`)
      .then(r => dispatch(fetchProposalTemplateSuccess(r.data)))
      .catch(e => dispatch(fetchProposalTemplateFailed(e)));
  };
};

export const fetchIntegrations = () => {
  return dispatch => {
    dispatch(fetchIntegrationsStart());
    return connectorAPI
      .get(`/integrations/providers`)
      .then(r => dispatch(fetchIntegrationsSuccess(r.data)))
      .catch(e => dispatch(fetchIntegrationsFailed(e)));
  };
};

export const disconnectIntegration = (companyId, provider) => {
  return dispatch => {
    return connectorAPI
      .delete(`/${companyId}/accounts?provider=${provider}`)
  };
};

// Zoho CRM fields schema
const fetchZohoCrmFieldsSchemaStart = () => {
  return { type: FETCH_ZOHO_CRM_FIELDS_SCHEMA_START };
};

const fetchZohoCrmFieldsSchemaSuccess = (result, module_slug) => {
  return { type: FETCH_ZOHO_CRM_FIELDS_SCHEMA_SUCCESS, result, module_slug };
};

const fetchZohoCrmFieldsSchemaFailed = error => {
  return { type: FETCH_ZOHO_CRM_FIELDS_SCHEMA_FAILED, error };
};

export const fetchZohoCrmFieldsSchema = ({ moduleName, extraParams }) => {
  const module_slug = moduleName.toLowerCase();
  const requestConfig = extraParams
    ? {
        headers: {
          "x-userid": extraParams.userId,
          "x-companyid": extraParams.companyId,
          "X-Auth": "NoAuth",
        },
      }
    : {};

  return dispatch => {
    dispatch(fetchZohoCrmFieldsSchemaStart());
    return connectorAPI
      .get(`/zoho-crm/${moduleName}/fields`, requestConfig)
      .then(r => dispatch(fetchZohoCrmFieldsSchemaSuccess(r.data.fields, module_slug)))
      .catch(e => dispatch(fetchZohoCrmFieldsSchemaFailed(e)));
  };
};

// Zoho CRM modules schema
const fetchZohoCrmModulesSchemaStart = () => {
  return { type: actionTypes.FETCH_ZOHO_CRM_MODULES_SCHEMA_START };
};

const fetchZohoCrmModulesSchemaSuccess = result => {
  return { type: actionTypes.FETCH_ZOHO_CRM_MODULES_SCHEMA_SUCCESS, result };
};

const fetchZohoCrmModulesSchemaFailed = error => {
  return { type: actionTypes.FETCH_ZOHO_CRM_MODULES_SCHEMA_FAILED, error };
};

export const fetchZohoCrmModulesSchema = () => {
  return dispatch => {
    dispatch(fetchZohoCrmModulesSchemaStart());
    return connectorAPI
      .get(`/zoho-crm/modules`)
      .then(r => dispatch(fetchZohoCrmModulesSchemaSuccess(r.data.modules)))
      .catch(e => dispatch(fetchZohoCrmModulesSchemaFailed(e)));
  };
};

//Fetch single collection specific config
export const fetchCollectionSpecificConfig  = (record_id) => {
  return dispatch => {
    dispatch(fetchCollectionSpecificConfigStart());
    return API.get(`/collections/config?colleection_id=${record_id}`)
      .then(r => dispatch(fetchCollectionSpecificConfigSuccess(r.data, `collection-${record_id}`)))
      .catch(e => dispatch(fetchCollectionSpecificConfigFailed(e)));
  };
};

export const updateCollectionSpecificConfig = (payload = {}, record_id) => {
  return dispatch => {
    dispatch(updateCompanyUserConfigStart());
    return API.put(`/config/update?colleection_id=${record_id}`, payload)
      .then(r => dispatch(updateCompanyUserConfigSuccess(r.data, `collection-${record_id}`)))
      .catch(e => dispatch(updateCompanyUserConfigFailed(e)));
    }
}
// Fetch company Proposal Currency List in public page
export const fetchProposalCurrencyList = companyId => {
  const endPoint = `/${companyId}/proposal/currency/list`;
  return dispatch => {
    return API.get(endPoint, {
      headers: {
        "X-Auth": "NoAuth",
      },
    });
  };
};

export const setUsedProposalModule = (company_id, params = {}, payload = {}) => {
  return dispatch => {
    return API.post(`/companies/${company_id}/proposal/settings/usage`, payload, {
      headers: {
        "X-Auth": "NoAuth",
      },
      params: params,
    });
  };
};

// Create Company Proposal Travel Supplier Module Record
export const createProposalTravelSupplierModuleRecord = payload => {
  return dispatch => {
    return API.post(`/proposal/travel_suppliers`, payload);
  };
};

// Update Company Proposal Travel Supplier Module Record
export const updateProposalTravelSupplierModuleRecord = (recordId, payload) => {
  return dispatch => {
    return API.put(`/proposal/travel_suppliers/${recordId}`, payload);
  };
};

// Delete Company Proposal Travel Supplier Image
export const deleteProposalModuleITravelSupplierImage = (recordId, imageIndex) => {
  return dispatch => {
    return API.delete(`/proposal/travel_suppliers/${recordId}/images/${imageIndex}/delete`);
  };
};

// Fetch company Proposal travel suppliers List By Supplier Type
export const fetchTravelSupplierByType = supplier_type => {
  const endPoint = `/proposal/travel_suppliers/filter?supplier_type=${supplier_type}`;
  return dispatch => {
    return API.get(endPoint);
  };
};

export const reOrderSignatureField = (form_id, payload, cluster) => {
  return dispatch => {
    dispatch(updateReorderSignatureFieldStart());
    return API.put(`/proposal/signature-forms/${form_id}/fields/reorder?cluster=${cluster}`, payload)
      .then(r => dispatch(updateReorderSignatureFieldSuccess(r.data)))
      .catch(e => dispatch(updateReorderSignatureFieldFailed(e)));
  };
};

const fetchZohoRecentlyModifiedDealStart = () => {
  return { type: FETCH_ZOHO_CRM_RECENTLY_MODIFIED_DEAL_START };
};

const fetchZohoRecentlyModifiedDealSuccess = result => {
  return { type: FETCH_ZOHO_CRM_RECENTLY_MODIFIED_DEAL_SUCCESS, result };
};

const fetchZohoRecentlyModifiedDealFailed = error => {
  return { type: FETCH_ZOHO_CRM_RECENTLY_MODIFIED_DEAL_FAILED, error };
};

export const fetchZohoCrmRecentlyMoidifiedDeal = () => {
  return dispatch => {
    dispatch(fetchZohoRecentlyModifiedDealStart());
    return connectorAPI
      .get(`/zoho-crm/deals`)
      .then(r => dispatch(fetchZohoRecentlyModifiedDealSuccess(r.data)))
      .catch(e => dispatch(fetchZohoRecentlyModifiedDealFailed(e)));
  };
};

const searchZohoCRMDealStart = () => {
  return { type: SEARCH_ZOHO_CRM_DEAL_START };
};

const searchZohoCRMDealSuccess = result => {
  return { type: SEARCH_ZOHO_CRM_DEAL_SUCCESS, result };
};

const searchZohoCRMDealFailed = error => {
  return { type: SEARCH_ZOHO_CRM_DEAL_FAILED, error };
};

export const searchZohoCrmDeal = (searchKeyword) => {
  return dispatch => {
    dispatch(searchZohoCRMDealStart());
    return connectorAPI
      .get(`/zoho-crm/deals/search?keyword=${searchKeyword}`)
      .then(r => dispatch(searchZohoCRMDealSuccess(r.data)))
      .catch(e => dispatch(searchZohoCRMDealFailed(e)));
  };
};